import React from 'react';
import { Droplets, VideoIcon, Wrench, Waves, Zap, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';

export default function ServicesSection() {
  const services = [
    {
      icon: Droplets,
      title: 'Drain Unblocking',
      description: 'Fast unblocking with advanced tools',
      color: 'from-slate-700 to-slate-900',
      span: 'lg:col-span-2'
    },
    {
      icon: Wrench,
      title: 'Drain Repair',
      description: 'Expert repair solutions',
      color: 'from-slate-700 to-slate-900',
      span: ''
    },
    {
      icon: Waves,
      title: 'Sewer Services',
      description: 'Complete sewer solutions',
      color: 'from-slate-600 to-slate-800',
      span: ''
    },
    {
      icon: Zap,
      title: 'Emergency 24/7',
      description: 'Always available',
      color: 'from-slate-700 to-slate-900',
      span: ''
    },
    {
      icon: Building2,
      title: 'Commercial',
      description: 'Business solutions',
      color: 'from-slate-600 to-slate-800',
      span: 'lg:col-span-2'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 mb-6">
            <span className="text-sm text-slate-600 font-medium">Our Services</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-slate-900 mb-6 leading-tight">
            Complete Drainage
            <span className="block font-bold">Solutions</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Professional services tailored to your drainage needs
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid lg:grid-cols-4 gap-6">
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.4 }}
              whileHover={{ scale: 1.05, rotateZ: idx % 2 === 0 ? 2 : -2 }}
              className={`${service.span} group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all overflow-hidden border border-slate-200`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 transition-opacity`} />
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6`}>
                <service.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3">{service.title}</h3>
              <p className="text-slate-600">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}